<template>
  <div>
    <div v-if="is_editing" class="is-flex is-align-items-center">
      <a @click="changeTiming" dir="rtl" class="button is-info">רוצה לשנות?</a>
      <div class="horizontal_space"></div>
      <p><u>{{time_helper.makeTimeReadable(selected_date)}}</u></p>
    </div>
  	<div v-else dir="ltr" class="is-flex is-flex-direction-column max-width-300px text_align_left">
      <a @click="pick('now')" class="snooze_chooser" :class="{ 'has-background-link-light': choosen == 'now' }"><p><b>Now</b></p><p class="calculated_time">({{now.calendar()}})</p></a>
      <div class="vertical_space"></div>
  		<a @click="pick('tomorrow')" class="snooze_chooser" :class="{ 'has-background-link-light': choosen == 'tomorrow' }"><p><b>Tomorrow</b></p><p class="calculated_time">({{tomorrow.calendar()}})</p></a>
  		<div class="vertical_space"></div>
  		<a @click="pick('three_more_days')" class="snooze_chooser" :class="{ 'has-background-link-light': choosen == 'three_more_days' }"><p><b>Three more days</b></p><p class="calculated_time">({{three_more_days.calendar()}})</p></a>
  		<div class="vertical_space"></div>
  		<a @click="pick('this_weekend')" class="snooze_chooser" :class="{ 'has-background-link-light': choosen == 'this_weekend' }"><p><b>This weekend</b></p><p class="calculated_time">({{this_weekend.calendar()}})</p></a>
  		<div class="vertical_space"></div>
  		<a @click="pick('next_week')" class="snooze_chooser" :class="{ 'has-background-link-light': choosen == 'next_week' }"><p><b>Next week</b></p><p class="calculated_time">({{next_week.calendar()}})</p></a>
  		<div class="vertical_space"></div>
  		<div>
  			<p>Pick a date and time</p>
  			<date-time @input="pickDate" :date="mutable_selected_date" class="is-justify-content-space-between"></date-time>
  		</div>
  	</div>
  </div>
</template>
<script>
import TimeHelper from '@/custom/classes/time_helper.js'
import DateTime from '@/components/DateTime'
export default {
  name: 'snooze',
  props: ['selected_date', 'pickDefault'],
  data () {
    let current_date = new Date()
    return {
      time_helper: new TimeHelper(),
      is_editing: (this.selected_date != undefined && this.selected_date.length > 0),
      now: this.$moment(current_date).add(0, 'days'),
      tomorrow: this.$moment(current_date).add(1, 'days'),
      three_more_days: this.$moment(current_date).add(3, 'days'),
      this_weekend: this.$moment(current_date).add(4 - current_date.getDay(), 'days'),
      next_week: this.$moment(current_date).add(7, 'days'),
      mutable_selected_date: this.selected_date != undefined ? this.selected_date : '',
      choosen: ''
    }
  },
  created () {
    this.init()
    if (this.pickDefault) {
      this.pick(this.pickDefault)
    }
  },
  methods: {
    async init () {
      this.now = await this.getBusinessDate({ days: 0 })
      this.tomorrow = await this.getBusinessDate({ days: 1 })
      this.three_more_days = await this.getBusinessDate({ days: 3 })
      this.this_weekend = await this.getBusinessDate({ days: 4 - new Date().getDay() })
      this.next_week = await this.getBusinessDate({ days: 5 })
    },
    async getBusinessDate (days) {
      return this.$moment(await this.$network_utils.getNextBusinessDate(days))
    },
    changeTiming () {
      this.is_editing = false
    },
    pick (date) {
      this.choosen = date
      this.pickDate(this[date])
    },
    pickDate (picked_date) {
      let date = new Date(picked_date).toUTCString()
      this.mutable_selected_date = date
      this.$emit('input', date)
    }
  },
  components: {
  	DateTime
  }
}
</script>
<style scoped>
	.picked{
		background-color: #ccc !important;
	}
	.calculated_time{
    white-space: nowrap;
    text-align: right;
		font-size: 14px;
	}
	.snooze_chooser{
		transition: all 0.2s;
		font-size: 15px;
		display: flex;
		justify-content: space-between;
		border-radius: 4px;
		padding: 3px 12px;
		text-align: left;
		color: var(--color-text);
		background-color: #f2f2f2;
	}
	.snooze_chooser:hover{
		background-color: rgba(0, 0, 0, 0.08);
	}
	.snooze_chooser a{
		text-align: left;
		color: var(--color-text);
	}
  .snooze_chooser p{
    margin: 0;
  }
	input[type="datetime-local"]{
		font-size: 15px;
		cursor: pointer;
		padding: 0;
		background-color: transparent !important;
		border-radius: 0;
		color: var(--color-text);
	}
</style>
